// extracted by mini-css-extract-plugin
module.exports = {"icon":"BaseIcon-icon-DFaPJ_6wF_","noMargin":"BaseIcon-noMargin-1NzOtixid8"};